module.exports = __webpack_public_path__ + "img/type-paper.71c4046.png?v=1750755973023";